import { Button, ErrorMessage, Screen, Text, TextInput } from "components"
import React, { useState } from "react"
import { Image, View } from "react-native"
import { style } from "./styles"
import { useNavigation } from "@react-navigation/native"
import { translate } from "i18n"
import { Controller, useForm } from "react-hook-form"
import flash from "config/flash"
import { useStores } from "models"
import { get } from "lodash"
import DropDownPicker from "react-native-dropdown-picker"
import { colors } from "colors"

export const EmployeeLoginScreen = () => {
  const navigation = useNavigation<any>()
  const [isLoading, setIsLoading] = useState(false)
  const { userStore } = useStores()

  const [open, setOpen] = useState(false)
  // State to manage the items in the dropdown
  const [company, setCompany] = useState([
    { label: "Company 1", value: "company1" },
    { label: "Company 2", value: "company2" },
    { label: "Company 3", value: "company3" },
  ])

  const { control, handleSubmit, clearErrors } = useForm({
    reValidateMode: "onSubmit",
  })

  const onSubmit = async (data) => {
    setIsLoading(true)
    await fetch(`${process.env.API_URL}/api/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: data?.email,
        pwd: data?.password,
        company_code: process.env.COMPANY_CODE,
      }),
    })
      .then(async (res) => {
        setIsLoading(false)
        if (res?.ok) {
          const responseData = await res?.json()

          flash("success", translate("loginScreen.loginSuccess"))
          userStore.update({
            id: get(responseData?.employee, "employee_id", "").toString(),
            accessToken: get(responseData, "accessToken", ""),
            role: "employee",
            fullName: get(responseData?.employee, "employee_name", "").toString(),
          })
          userStore?.updateIsLoggedIn(true)
          navigation.navigate("employeeMenu")
        } else {
          flash("error", translate("loginScreen.failedToLogin"))
        }
      })
      .catch(() => {
        flash("error", translate("loginScreen.failedToLogin"))
        setIsLoading(false)
      })
  }

  return (
    <Screen>
      <View style={style.container}>
        <Text style={style.titleText}>{translate("employeeLoginScreen.title")}</Text>
        <Image source={require("assets/dekode-icon.png")} style={style.logoImage} />
        <View style={style.mv30}>
          <Controller
            name="email"
            control={control}
            rules={{
              required: translate("errors.required"),
              pattern: {
                value:
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: translate("errors.invalidEmail"),
              },
            }}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
              return (
                <>
                  <TextInput
                    onFocus={() => clearErrors("email")}
                    error={error}
                    errorMessage={error?.message}
                    title={translate("editProfileScreen.email")}
                    value={value}
                    onChangeText={onChange}
                    autoCapitalize="none"
                    autoComplete="email"
                    autoCorrect={false}
                    placeholder={translate("editProfileScreen.emailPlaceholder")}
                  />
                </>
              )
            }}
          />

          <Controller
            name="password"
            control={control}
            rules={{
              required: translate("errors.required"),
            }}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
              return (
                <View>
                  <TextInput
                    onFocus={() => clearErrors("password")}
                    value={value}
                    onChangeText={onChange}
                    error={error}
                    isPasswordField
                    title={translate("employeeLoginScreen.password")}
                    errorMessage={error?.message}
                    placeholder={translate("employeeLoginScreen.passwordPlaceholder")}
                    containerStyle={style.inputContainer}
                    style={style.inputStyle}
                  />
                </View>
              )
            }}
          />

          {/* <Controller
            name="dropdown"
            control={control}
            rules={{
              required: translate("errors.required"),
            }}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
              return (
                <>
                  <View style={style.dropdownContainer}>
                    <View style={style.titleContainer}>
                      <Text style={style.title2}>{translate("employeeLoginScreen.company")}</Text>
                    </View>
                    <DropDownPicker
                      style={[style.dropdown, error && style.errorTextField]}
                      open={open}
                      value={value}
                      items={company}
                      setOpen={setOpen}
                      setValue={onChange}
                      setItems={setCompany}
                      placeholder="Select an option"
                      listMode="MODAL"
                      stickyHeader={true}
                      placeholderStyle={{
                        color: colors.placeholder,
                      }}
                      dropDownContainerStyle={{
                        borderColor: colors.inputFieldBorder,
                        backgroundColor: colors.placeholder,
                      }}
                    />
                    {error && (
                      <ErrorMessage errorType={error.type} customMessage={error?.message} />
                    )}
                  </View>
                </>
              )
            }}
          /> */}
        </View>

        <View style={style.buttonContainer}>
          <Button
            loading={isLoading}
            onPress={handleSubmit(onSubmit)}
            style={style.loginButton}
            title={translate("common.login")}
          />
        </View>
      </View>
    </Screen>
  )
}
